<template>
  <div>
    <!-- Desktop layout - side by side -->
    <div class="hidden md:flex justify-between items-start mb-4">
      <h1 class="text-3xl font-bold text-blue-400 max-w-[70%] break-words">
        {{ product.name }}
      </h1>
      <div
        class="text-2xl font-bold text-green-400 bg-gray-700 p-2 rounded-md ml-3 min-w-[130px] text-right shadow-inner"
      >
        {{ formatPrice(product.price) }}
      </div>
    </div>

    <!-- Mobile layout - stacked -->
    <div class="md:hidden mb-4">
      <h1
        class="text-2xl font-bold text-blue-400 break-words overflow-wrap-anywhere mb-3"
      >
        {{ product.name }}
      </h1>
      <div
        class="text-xl font-bold text-green-400 bg-gray-700 p-2 rounded-md shadow-inner text-center max-w-fit"
      >
        {{ formatPrice(product.price) }}
      </div>
    </div>

    <div class="flex items-center mb-4">
      <div
        class="flex items-center px-3 py-1 bg-gray-700 rounded-full text-sm text-blue-400 break-words overflow-wrap-anywhere"
      >
        <span v-if="product.category.parent">
          {{ product.category.parent.name }} &gt; {{ product.category.name }}
        </span>
        <span v-else>
          {{ product.category.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { Product } from '@/composables/useProductDetail';

export default defineComponent({
  name: 'ProductHeader',
  props: {
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
    formatPrice: {
      type: Function as PropType<(price: string) => string>,
      required: true,
    },
  },
});
</script>

<style scoped>
/* Dodatne mobilne optimizacije */
@media (max-width: 768px) {
  h1 {
    word-break: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
    max-width: 100%;
    width: 100%;
    line-height: 1.3;
  }

  .text-blue-400 span {
    word-break: break-word;
    overflow-wrap: anywhere;
  }
}

@media (max-width: 480px) {
  h1 {
    font-size: 1.5rem;
    line-height: 1.4;
  }

  .text-xl {
    font-size: 1.25rem;
  }

  .text-sm {
    font-size: 0.8rem;
  }
}
</style>
